import type {Transport} from "./Transport";
import "./ConsentPopup.css";
import type {Locale} from "./Locale";

export class ConsentPopup {

	static MODAL_ID = 'cookie-consent';
	static defaults = {
		acceptElement: '[data-action="accept"]',
		bodyElement: '[data-entity="body"]',
		template: (locale: Locale) => {
			return `
				<div data-entity="body">${locale.get('LOADING')}</div>
				<div class="td-cookie-consent-popup__actions">
					<button class="btn" type="button" data-action="accept">${locale.get('OK')}</button>
				</div>
			`;
		},
	}

	//<span class="b-modal-content__title-action b-modal-content__title-action--fill">оставьте свои <b>пожелания по
	// туру</b></span><span class="b-modal-content__title-hint">ответим <b>оперативно!</b></span>

	constructor(transport: Transport, locale: Locale) {
		this.options = Object.assign({}, ConsentPopup.defaults);
		this.transport = transport;
		this.locale = locale;
	}

	bind(): void {
		this.handleAccept(true);
	}

	unbind(): void {
		this.handleAccept(false);
	}

	handleAccept(dir: boolean): void {
		const button = this.fancybox.container.querySelector(this.options.acceptElement)

		button[dir ? 'addEventListener' : 'removeEventListener']('click', this.onAccept);
	}

	onAccept = (): void => {
		const fn = this._resolve;
		this.hide();
		fn();
	}

	onClose = (): void => {
		this.unbind();
		this._resolve = null;
		this._reject = null;
		this.el.remove();
		this.el = null;
	}

	show(): Promise<void> {
		return new Promise((resolve, reject) => {
			try {
				this.open().then(() => {
					this.bind();
					this.load();
				});

				this._resolve = resolve;
				this._reject = reject;
			} catch (e) {
				console.error(e);
			}
		});
	}

	open(): Promise {
		return new Promise((resolve) => {
			this.fancybox = new Fancybox([
				{
					src: this.options.template(this.locale),
					type: 'html'
				},
			], {
				// Main container styling (centered)
				placeFocusBack: false,  // Prevents focus jumping after close
				autoFocus: false,       // Disables auto-focusing the first element
				dragToClose: false,     // Disable dragging to close
				backdropClick: false,   // Disable closing when clicking outside
				mainClass: "fancybox-centered-modal", // Custom CSS class (optional)

				// Layout & positioning
				Layout: {
					type: 'center',      // Forces center alignment
					padding: 40,        // Adds space around the modal
				},

				// Toolbar (optional)
				Toolbar: {
					display: false,     // Hide toolbar buttons
				},

				// Disable slide interactions
				Thumbs: {
					type: false,        // Disable thumbnails
				},
				Carousel: {
					infinite: false,    // Disable sliding between slides
				},
			});

			this.fancybox.on('reveal', () => {
				resolve(this.fancybox);
			})
		});
	}

	hide(): void {
		if (this.fancybox == null) { return; }

		this.fancybox.close();
		this.fancybox = null;
	}

	async load(): void {
		const body = this.fancybox.container.querySelector(this.options.bodyElement);

		if (body == null) { return; }

		try {
			body.innerHTML = await this.transport.getText();
		} catch (error) {
			body.textContent = error.message;
		}
	}
}
